import React from 'react';

import Skeleton from '@atlaskit/skeleton';

export default (): React.JSX.Element => <Skeleton width="40px" height="40px" borderRadius="20px" />;
